export type LivenessErrorType =
  | 'poor_lighting'
  | 'face_misaligned'
  | 'timeout_abandon'
  | 'device_error'
  | 'liveness_access_denied'
  | 'generic_liveness'

export type SelfiePhase =
  | { phase: 'capturing'; cameraReady: boolean }
  | { phase: 'processing' }
  | { phase: 'help'; errorType: LivenessErrorType; attempts: number }

export const MAX_SELFIE_ATTEMPTS = 3
